export default {
  common_button_back: 'Natrag',
  common_button_cancel: 'Otkaži',
  common_button_next: 'Dalje',
  common_button_no: 'Ne',
  common_button_ok: 'Ok',
  common_button_reset: 'Reset',
  common_button_skip: 'Preskoči',
  common_button_yes: 'Da',
  common_deactivated_message:
    'Kiosk app je aktiviran na drugom iPad_u i nije više aktivan na ovom. Molimo prijavite se ponovo. Hvala!',
  common_deactivated_title: 'Kiosk app je deaktiviran na ovom iPad_u',
  common_enterEmail_email: 'Unesite vaš poslovni e-mail',
  common_enterEmail_title: 'Unesite vašu E-poštu',
  common_error_message_cameraNotAllowed: 'Za ovu funkciju potreban je pristup kameri.',
  common_error_message_ForbiddenException: 'Žao mi je, čini se da nemate dovoljno prava za izvođenje ove akcije',
  common_error_message_incorrectEmail: 'Molimo unesite ispravnu e-mail adresu',
  common_error_message_invalidCredentials: 'Ups! Korisničko ime ili lozinka nisu ispravni. Molimo pokušajte ponovno',
  common_error_message_invalidMobile: 'Unesite ispravan broj mobitela',
  common_error_message_missingField: 'Obavezno polje',
  common_error_message_noInternetConnection: 'Internetska veza je prekinuta. Molimo pokušajte ponovo.',
  common_error_message_unauthorizedAccess: 'Neovlašten pristup',
  common_error_message_webServiceWrongConnection:
    'Došlo je do pogreške tijekom prijenosa podataka. Molimo pokušajte ponovno',
  common_error_title: 'Greška',
  common_expired_message:
    'Vaša probna verzija je istekla ili je kreditna kartica koju koristite prestala važiti. Molimo nadogradite aplikaciju kako bi ponovo aktivirali račun. Ako imamte bilo kakvih pitanja, slobodno se obratite na sales@proxyclick.com. Hvala!',
  common_expired_title: 'Račun je istekao',
  common_onboarding_login_button: 'Prijavite se',
  common_onboarding_message1: 'Proxyclick pomaže vam dočekati vaše posjetitelje na način koji vi želite.',
  common_onboarding_message2:
    'Prilagodite vaš proces prijave i bedževa, i postavite svojim posjetiteljima samo pitanja koja se na njih odnose.',
  common_onboarding_message3: 'Domaćini dobijaju obavijest kada njihovi gosti stignu i može odgovoriti odmah.',
  common_onboarding_message4:
    'Zaštitite vaše objekate i uskladite se s pravilima o zaštiti podataka, uredite liste za evakuaciju, politike i izjave o povjerljivosti...',
  common_onboarding_message5: 'Proxyclick radi težak posao tako da vi možete dočekati svoje posjetitelje sa smiješkom.',
  common_placeholder_optional: 'Opcija',
  common_setup_activationCode_activate_button: 'Aktiviraj',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Npr. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Pogrešan aktivacijski kod',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Aktivirajte kiosk sa jedinstvenom šifrom',
  common_setup_device_footer: 'Za stvaranje nove lokacije, povežite se na Proxyclick nadzornu ploču',
  common_setup_device_locked_content:
    'Ovaj kiosk je već u uporabi na drugom iPad_u. Postavljanje na ovaj iPad će isključiti kiosk na drugom. Jeste li sigurni da želite postaviti kiosk na ovaj iPad?',
  common_setup_device_locked_continue_button: 'Postaviti ovaj kiosk',
  common_setup_device_locked_title: 'Kiosk već u upotrebi',
  common_setup_device_multiTenants: 'Više tvrtki',
  common_setup_device_title: 'Odaberite svoj kiosk',
  common_setup_loading_footer: 'Da bi ste prilagodili svoj kiosk, povežite se na Proxyclick nadzornu ploču',
  common_setup_loading_message: 'Konfiguracija...',
  common_setup_loading_title: 'Vaš kiosk se priprema...',
  common_setup_location_footer: 'Za stvaranje nove lokacije, povežite se na Proxyclick nadzornu ploču',
  common_setup_location_kiosk: 'kiosk',
  common_setup_location_kiosks: 'kiosci',
  common_setup_location_title: 'Odaberite svoju lokaciju',
  common_setup_login_activationCode_button: 'Aktivirajte sa jedinstvenom šifrom?',
  common_setup_login_email: 'E-pošta',
  common_setup_login_forgotPassword_button: 'Zaboravili ste lozinku?',
  common_setup_login_password: 'Lozinka',
  common_setup_login_title: 'Prijavite se pomoću vašeg Proxyclick računa',
  common_setup_ready_header: 'Spremni za postaviti ovaj iPad kao {0} kiosk?',
  common_setup_ready_message: 'Potrebno je samo minuta za konfiguraciju i vaš kiosk će biti spreman',
  common_setup_ready_setup_button: 'Set up',
  common_setup_ready_title: 'Hi {0}',
  common_signup_company: 'Tvrtka',
  common_signup_email: 'E-pošta',
  common_signup_error_name: 'Molimo unesite ime i prezime',
  common_signup_loading_message1:
    'Vaš kiosk možete prilagoditi iz Proxyclick nadzorne ploče. Poslali smo vam e-mail sa svim detaljima za povezivanje.',
  common_signup_loading_message2: 'Na web stranici možete postaviti pisač za ispis Id najepnica prilikom prijave.',
  common_signup_loading_message3:
    'Također možete omogućiti i slanje obavijesti domaćinu prilikom prijave posjetitelja.',
  common_signup_loading_message4: 'I prilagoditi svoj kiosk sa svojim vlastitim bojama i slikom za dobrodošlicu.',
  common_signup_loading_title: 'Postavljanje računa…',
  common_signup_name: 'Ime',
  common_signup_name_placeholder: 'Ime i prezime',
  common_signup_password: 'Lozinka',
  common_signup_title: 'Dobrodošli u Proxyclick',
  common_signup_tryFree_button: 'Probna verzija',
  common_timeout_content: 'Dodirnite za prekid',
  common_timeout_title: 'Povratak na početni zaslon',
  common_tooltip_disable_button: 'Nemoj više prikazivati savjete',
  common_tooltip_gotIt_button: 'Kužim',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} je obavješten o dostavi paketa',
  dm_delivery_confirmation_title: 'Hvala!',
  dm_delivery_confirmation_unknownRecipient: '{{Company_Name}} je poslana obavijest o dostavi paketa',
  dm_delivery_recipient_name: 'Za koga je dostava?',
  dm_delivery_recipient_unknown_button: 'Ne znam',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Registrirani ste!',
  vm_checkin_confirmation_header_withPrint: 'Vaša karta se ispisuje',
  vm_checkin_confirmation_message: 'Molimo sačekajte, {{Host_FirstName}} je obaviješten o vašem dolasku',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Hvala!',
  vm_checkin_details_companyName: 'Tvrtka',
  vm_checkin_details_email: 'E-pošta',
  vm_checkin_details_firstname: 'Ime',
  vm_checkin_details_lastname: 'Prezime',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    'Dogodila se pogreška prilikom završetka vaše prijave, obratite se recepciji',
  vm_checkin_flow_company: 'Tvrtka',
  vm_checkin_flow_duration: 'Trajanje posjeta',
  vm_checkin_flow_email: 'E-pošta',
  vm_checkin_flow_error_message_imageNotAvailable: 'Ups, slika trenutno nije dostupna (Problem s internet vezom)',
  vm_checkin_flow_licensePlate: 'Registarske pločice',
  vm_checkin_flow_mobile: 'Unesite broj vašeg mobitela',
  vm_checkin_flow_mobile_info: 'Ovo će se koristiti za obavijesti u slučaju opasnosti dok ste u pogonu',
  vm_checkin_flow_tooltip_content:
    'Pitajte svoje posjetitelje kako poboljšati iskustvo ili sigurnost prijave. Možete promijeniti protok pitanja ovisno o odgovoru posjetitelja. pitanja koja vidite su samo uzorci za demo.',
  vm_checkin_flow_tooltip_title: 'Pametna pitanja',
  vm_checkin_host_enterFullName: 'Molimo unesite puno ime vašeg domaćina',
  vm_checkin_host_name: 'Koga posječujete?',
  vm_checkin_host_notListed_block:
    'Ako ne znate tko je vaš domaćin ili se ne nalazi na popisu, porazgovarajte o tome s portirom',
  vm_checkin_host_notListed_continue: 'Nije na popisu',
  vm_checkin_host_tooltip_content:
    'Upišite svoje ime i poslat ćemo vam e-mail obavijest kad vaši zaposlenici imaju posjet.',
  vm_checkin_host_tooltip_title: 'Obavjest o dolasku',
  vm_checkin_host_unknown_button: 'Ne znam',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Više',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Slažem se',
  vm_checkin_instructions_clearSignature_button: 'Obriši potpis',
  vm_checkin_instructions_sendCopy_button: 'Pošaljite mi kopiju putem e-pošte',
  vm_checkin_instructions_sendCopyTo_button: 'Kopija će biti poslana na {0}',
  vm_checkin_instructions_sign: 'Potpišite ovdje prstom ili olovkom',
  vm_checkin_instructions_tooltip_content:
    'Omogućite posjetiteljima da prihvate vaša pravila posjeta jednostavnim dodirom ili potpisom. Možete prilagoditi uvjete ovisno o vrsti posjetitelja. Prilagodite ovu značajku kao i mnoge druge u Proxyclick nadzornoj ploči.',
  vm_checkin_instructions_tooltip_title: 'Potpisano i zaključeno',
  vm_checkin_method_name: 'Pozdrav, molimo upišite svoje ime',
  vm_checkin_method_name_enterFullName: 'Molimo unesite vaše ime',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Nije na popisu? Molimo provjerite sa portirom',
  vm_checkin_method_name_notRegistered_continue: 'Nije na popisu?',
  vm_checkin_method_tooltip_content:
    'Prijavi se kao "Justin Diaz" da vidite kako se prethodno registrirani posjetitelji su prepoznaju. Ili upišite bilo koje ime da biste vidjeli kako se procesuiraju neočekivani gosti.',
  vm_checkin_method_tooltip_title: 'Prepoznavanje posjetitelja',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Napravite fotografiju',
  vm_checkin_picture_title: 'Napravite fotografiju!',
  vm_checkin_picture_tooltip_content:
    'Možete prilagoditi kiosk na vaše potrebe i lako dodati ili ukloniti značajke kao što su fotografiranje ili ispis karte.',
  vm_checkin_picture_tooltip_title: 'Dodatne značajke',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: 'Pozdrav, upišite vašu adresu E-pošte?',
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Spremi moje informacije za buduće prijave',
  vm_checkin_saveInfo_email_placeholder: 'Unesite adresu e-pošte',
  vm_checkin_saveInfo_title: 'Unesite vaš e-mail',
  vm_checkin_summary_agreementAlreadySigned: 'Sporazum već potpisan',
  vm_checkin_summary_checkin_button: 'Prijavite se',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Uredi detalje',
  vm_checkin_summary_groupStats: '{0} od {1} osoba je već tamo',
  vm_checkin_summary_meetingTime: 'Sastanak u {0}',
  vm_checkin_summary_reviewDetails_button: 'Pregled detalja posjeta',
  vm_checkin_summary_sendPass_button: 'Pošaljite mi kartu za buduće posjete na moj pametni telefon',
  vm_checkin_summary_sendPassTo_button: 'Stalna karta će biti poslana na {0} (promjeni)',
  vm_checkin_summary_takeNewPicture_button: 'Nova slika',
  vm_checkin_summary_title: 'Vaš posjet u {{Company_Name}}',
  vm_checkin_summary_visiting: 'Posjeti {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Dobrodošli {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Vaš zadnji posjet bio je {0}',
  vm_checkin_welcome_lastVisit_today: 'Vaš zadnji posjet bio je danas',
  vm_checkin_welcome_lastVisit_yesterday: 'Vaš zadnji posjet bio je jučer',
  vm_checkin_welcome_returning: 'Dobrodošli natrag {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Doviđenja {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Vi ste odjavljeni. Nadamo se da ste imali ugodnu posjetu.',
  vm_checkout_confirmation_title: 'Hvala vam na posjeti!',
  vm_checkout_method_name: 'Please enter your name in order to check out',

  vm_checkout_method_name_notFound: 'Nije pronađeno',
  vm_checkout_method_title: 'Odjava',
  vm_identification_id_button: 'Skenirajte vašu osobnu iskaznicu',
  vm_identification_qrCode_button: 'Skenirajte vašu pozivnicu/kartu',
  vm_infopack_confirmation: 'Hvala, poslali smo e-mail na {0}.',
  vm_infopack_email: 'Molimo unesite vaš e-mail tako da vam možemo poslati informacije o Proxyclick_u',
  vm_infopack_likeCheckIn: 'Sviđa mi se način prijave? Dodirnite da biste saznali više',
  vm_infopack_likeProcess: 'Sviđa mi se način prijave? Dodirnite da biste saznali više',
  vm_infopack_send_button: 'Pošalji',
  vm_multiTenant_title: 'Dobrodošli, koju tvrtku posjećujete?',
  vm_product_footer_learnMore: 'Više',
  vm_product_footer_noPartner: 'Koristite Proxyclick Dobrodošli',
  vm_product_footer_partner: 'Koristite Proxyclick Dobrodošli, za vas pripremio {0}',
  vm_qrCode_help: 'Držite svoj kod 10-15 cm od kamere',
  vm_qrCode_not_recognized: 'Kod nije prepoznat',
  vm_qrCode_title: 'Skenirajte vašu vizit kartu ili kod za prolaz',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>posjetitelja upute i tajnost sporazuma</h1><p>Dobrodošli! Zadovoljni smo da ste kao gost {{Company_Name}} u našim objektima.</p> <h2>zdravstvene i sigurnosne upute</h2> <p>tijekom vašeg posjeta tvoje osobne sigurnosti je naša briga. Stoga vas molimo da se pridržavaju sljedećeg:</p><ul><li><b>pristup u prostorije</b> je dopušteno samo ako je popraćen {{Company_Name}} zaposlenika</li><li>posjetitelja <b>značku</b> Mora se nositi u svako doba i treba vratiti recepciji po odlasku</li><li>u slučaju je <b>hitne</b>, sve posjetitelja morate napustiti ovo mjesto odmah preko najbliži siguran izlaz i izvješće skupštini prostor za točke</li><li>posjetitelja su <b>zabranjeno je hvatanje slike</b> (fotografije i video) sve unutar prostora ili okružuje objekt dvorište</li><li><b>Pušenje je strogo zabranjeno</b> u zgradi</li></ul><h2>ugovora o tajnosti</h2><p>tijekom posjete {{Company_Name}}objekta, vi svibanj naučiti ili su objavljeni vlasničke i povjerljive informacije (uključujući, bez ograničenja, informacije koje se odnose na tehnologija, procesa, opreme, crteži i specifikacije) koji općenito nisu poznati javnosti (u daljnjem tekstu skupno nazivaju &#34;povjerljive informacije&#34;).</p> <p>uzimajući u obzir vaše dopuštenje da posjeti {{Company_Name}}objekt i courtesies proširen tijekom vašeg posjeta, suglasni ste suglasni da nećete, ni;</p> <p>(i) otkriti ili drugi način učiniti dostupnim drugima bilo kakve povjerljive informacije objavljeni na vas tijekom ove i bilo koje naknadne posjete; ili</p><p>(b) korištenje ili pomoći drugima u koristeći ili daljnji razvoj na bilo koji način bilo kakve povjerljive informacije.</p> <p>(c) korištenje kamere ili video tehnologija to otkriti povjerljive informacije.</p> <p>potpisivanjem u objekt, prihvaćate i razumijete zdravstvene i sigurnosne upute i Non-Disclosure sporazuma objavljeno.</p>',
  vm_signup_defaultInstruction_name: 'Upute za potpis od strane svih posjetitelja',
  vm_signup_defaultInstruction_title: 'Molimo pročitajte i potpišite ispod',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change language',
  vm_welcome_checkin_button: 'Prijavite se',
  vm_welcome_checkout_button: 'Odjavite se',
  vm_welcome_delivery_button: 'Dostava',
  vm_welcome_hello_line1: 'Dobrodošli',

  vm_welcome_hello_line2: 'molimo vas da se prijavite',

  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Ja sam bio ovdje prije',
  vm_welcome_title: 'Dobrodošli u {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Da biste prilagodili svoj kiosk, prijavite se na Proxyclick nadzornu ploču. Poslali smo vam e-mail sa uputama. Na nadzornoj ploči možete učitati vaš logo, pozadinske slike i odabrati boju tako da sve odražava identitet vaše tvrtke.',
  vm_welcome_tooltip_title: 'Napravite svoj vlastiti',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'ili',
};
